var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Copy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.241,
    height: 10.7,
    viewBox: "0 0 9.241 10.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-content-copy",
    "data-name": "Icon material-content-copy",
    d: "M7.809.5H1.973A.976.976,0,0,0,1,1.473V8.282h.973V1.473H7.809ZM9.268,2.445H3.918a.976.976,0,0,0-.973.973v6.809a.976.976,0,0,0,.973.973h5.35a.976.976,0,0,0,.973-.973V3.418A.976.976,0,0,0,9.268,2.445Zm0,7.782H3.918V3.418h5.35Z",
    transform: "translate(-1 -0.5)",
    fill: "#185cff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageCopy);
export default __webpack_public_path__ + "static/media/manage-copy.85fd2da86c9e9881aa3dff18cb6272b3.svg";
export { ForwardRef as ReactComponent };